
const roundValue = (value, decimals) => {
  if(value === undefined) return value;
  if(value === null) return value;
  if(isNaN(value)) return value;
  if(value.toFixed === undefined) return value;

  value = parseFloat(value.toFixed(decimals + 1));

  // var retval = Number(Math.round(value+'e'+decimals)+'e-'+decimals);

  // var stringVersion = value.toFixed(decimals);
  // var stringVersionPlus = value.toFixed(decimals + 1);

  // if(stringVersion[stringVersion.length - 1] === '0' && stringVersionPlus[stringVersionPlus.length - 1] !== '0'){
  //   retval += '0';
  // }

  return value;//retval;
}

export default roundValue;


// WEBPACK FOOTER //
// ./src/pattern_utilities/roundValue.js